import React from 'react'
import { Chip } from '@mui/material'
import { grey } from '@mui/material/colors'
import { ChipProps } from './Chip.types'

const ChipComponent: React.FC<ChipProps> = ({ chipTitle, link }) => {
  const styles = {
    root: {
      background: 'transparent',
      border: `1px solid ${grey[400]}`,
      padding: '15px',
      margin: '5px',
    },
  }

  const handleChipClick = (heading: string) => {
    const id = heading.slice(1)
    const root = document.querySelector(`[data-scroll-id=${id}]`)
    if (root) root.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  return <Chip sx={styles.root} label={chipTitle} key={link} onClick={() => handleChipClick(link)} variant="outlined" />
}

export default ChipComponent
